import React from "react";
import { Collapsible, CollapsibleContent } from "@/components/ui/collapsible";
import { NearbyFacilityItem } from "@/components/facility/NearbyFacilityItem";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";
import { FacilityMap } from "@/components/Map/FacilityMap";
import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";

interface NearbyCollapseProps {
    isOpen: boolean;
    onToggle: () => void;
    children: React.ReactNode;
    className: string;
    dataAttributes: object;
}

export const NearbyCollapse = ({
    isOpen,
    onToggle,
    children,
    className,
    dataAttributes,
}: NearbyCollapseProps) => {
    const { facilityMap } = useDisplayOptionContext();
    const { unitGroup } = useUnitItemContext();

    const facilities = unitGroup.nearby_units.map((unit) => unit.facility);

    return (
        <>
            <Collapsible
                open={isOpen}
                onOpenChange={onToggle}
                className={className}
                {...dataAttributes}
            >
                {children}
                <CollapsibleContent className="unit-item__nearby unit-item__nearby-collapse-content tw:flex tw:flex-wrap tw:w-full">
                    <div className="unit-item__nearby-panel tw:w-full tw:p-6 tw:bg-white tw:rounded-lg tw:shadow">
                        <h4 className="unit-item__nearby-title tw:text-md tw:mb-4">
                            Similar sized units are available at these nearby
                            locations
                        </h4>

                        <div className="unit-item__nearby-list tw:grid tw:grid-cols-1 tw:lg:grid-cols-3 tw:gap-6">
                            {/*left panel*/}
                            <div className="unit-item__nearby-cards tw:lg:col-span-2 tw:space-y-4 tw:overflow-y-auto tw:pr-2 tw:order-2 tw:lg:order-1">
                                {/*Location Card*/}
                                {/* Loop through the nearby units */}
                                {unitGroup.nearby_units.map((unit, index) => (
                                    <NearbyFacilityItem
                                        key={unit.facility.id}
                                        distance={unit.facility.distance}
                                        address1={unit.facility.address_1}
                                        address2={unit.facility.address_2}
                                        city={unit.facility.city}
                                        state={unit.facility.state}
                                        zip={unit.facility.zipcode}
                                        name={unit.facility.name}
                                        imageUrl={
                                            facilityMap[unit.facility.id]
                                                ?.featuredImage || ""
                                        }
                                        facilityUrl={
                                            facilityMap[unit.facility.id]
                                                ?.url || ""
                                        }
                                        unitTypeName={
                                            unitGroup?.representative_unit
                                                ?.unit_type_name
                                        }
                                        pinNumber={index + 1}
                                    />
                                ))}
                            </div>

                            {/*Right panel (map placeholder)*/}
                            <div className="unit-item__nearby-map tw:relative tw:w-full tw:h-[300px] tw:sm:h-[400px] tw:rounded-lg tw:order-1 tw:lg:order-2">
                                <FacilityMap
                                    facilities={facilities}
                                    height={"100%"}
                                    width={"100%"}
                                ></FacilityMap>
                            </div>
                        </div>
                    </div>
                </CollapsibleContent>
            </Collapsible>
        </>
    );
};
